import Box from '@gogame/ui/Box';

export const DraggableDialogContent = ({ children, sx = {} }) => {
  return (
    <Box
      component={'div'}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        ...sx,
      }}
    >
      <Box
        component={'div'}
        sx={{
          width: 'inherit',
          maxWidth: '800px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
